module.exports = __webpack_public_path__ + "814303e80b83d9de5c3a0fb8a00d31a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lyrics_book.jpg
// module id = 278
// module chunks = 0